import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { TableColumnsFilter } from 'common/ColumnsFilter/ColumnsFilter';
import { FilterButton } from 'common/FilterButton/FilterButton';
import type { TeacherWorkloadsTableRow } from 'widgets/teacher-workloads-table/model';
import type { Key } from 'react';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import styles from './Controls.module.scss';

type TeacherWorkloadControlsProps = {
  onCreateTeacherWorkload: () => void;
  columns: AppTableColumn<TeacherWorkloadsTableRow>[];
  visibleKeys: Key[];
  setVisibleKeys: (activeKeys: Key[]) => void;
  filterCount?: number;
  showSider: () => void;
};

export const TeacherWorkloadControls = ({
  onCreateTeacherWorkload,
  visibleKeys,
  columns,
  setVisibleKeys,
  showSider,
  filterCount,
}: TeacherWorkloadControlsProps) => {
  return (
    <AppFlex direction="row" justifyContent="flex-end" className={styles.controls}>
      <AppButton onClick={onCreateTeacherWorkload}>Создать</AppButton>
      <FilterButton count={filterCount} click={showSider} />
      <TableColumnsFilter
        visibleKeys={visibleKeys}
        columns={columns}
        setVisibleKeys={setVisibleKeys}
      />
    </AppFlex>
  );
};
